import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { IN_ROOM_DINING_CUSTOMISATIONS_EDIT } from '../../../../../constants/InRoomDiningConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_SERVICES_IN_ROOM_DINING,
} from '../../../../../constants/RoleConsts';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import { inRoomDiningCustomisationsSelector } from '../../../servicesSlice';
import InRoomDiningCustomisationViewDetail from './Customisation-View-Details';

const InRoomDiningCustomisationView = (props) => {
  const { customisation, toggleDrawer, onViewToggle, permissions } = props;
  const inRoomDiningCustomisation = useSelector(inRoomDiningCustomisationsSelector);
  const [tabValue, setTabValue] = useState(0);
  const [currCustomisation, setCurrCustomisation] = useState(null);

  useEffect(() => {
    if (inRoomDiningCustomisation.length) {
      let customisationObj = {
        ...inRoomDiningCustomisation.find((temp) => temp.id === customisation.id),
      };
      setCurrCustomisation(customisationObj);
    }
  }, [inRoomDiningCustomisation]);

  const onOpenDrawer = (type) => {
    toggleDrawer(type, true, currCustomisation);
  };

  const onClickEdit = (event) => {
    onOpenDrawer(IN_ROOM_DINING_CUSTOMISATIONS_EDIT);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderScreen = () => {
    return (
      <InRoomDiningCustomisationViewDetail tabValue={tabValue} customisation={currCustomisation} />
    );
  };

  return (
    <>
      {currCustomisation && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          handleTabChange={handleTabChange}
          tabValue={tabValue}
          onViewToggle={onViewToggle}
          title={currCustomisation.name}
          createdUserId={currCustomisation.createdBy}
          isEditable={
            permissions[RBAC_TYPE_SERVICES_IN_ROOM_DINING] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
          }
          tabClass='col-md-6'
        />
      )}
    </>
  );
};

export default InRoomDiningCustomisationView;
